'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.getOrderTimeGuaranteeText = getOrderTimeGuaranteeText;
exports.getCartTimeGuaranteeText = getCartTimeGuaranteeText;

var _FutureDeliveryHelper = require('./FutureDeliveryHelper');

var _FutureDeliveryHelper2 = _interopRequireDefault(_FutureDeliveryHelper);

var _Order = require('../Order');

var _Order2 = _interopRequireDefault(_Order);

var _Restaurant = require('../Restaurant');

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _Time = require('../../Time');

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOrderTimeGuaranteeText(order, i18n, timezone) {
    var delayMins = _Order2.default.getDelayMins(order);
    var txt = new TextProvider(i18n, timezone);
    var hasDelayMins = delayMins > 0;

    if (_Order2.default.isAsap(order)) {
        return hasDelayMins ? txt.asapWithDelay(delayMins) : txt.asapWithoutDelay();
    } else if (_Order2.default.isPreorder(order)) {
        return hasDelayMins ? txt.preorderWithDelay(order.submitAt, delayMins) : txt.preorderWithoutDelay(order.submitAt);
    } else {
        return txt.futureOrder(order.delivery.time);
    }
}

function getCartTimeGuaranteeText(organization, cart, i18n) {
    var deliveryInfo = _Restaurant2.default.getCartDeliveryInfo(organization, cart);
    var delayMins = deliveryInfo && deliveryInfo.delayMins || 0;
    var hasDelayMins = delayMins > 0;
    var txt = new TextProvider(i18n, organization.timezone);
    var foCart = _FutureDeliveryHelper2.default.isFutureOrderCart(cart);
    var preorderCart = _FutureDeliveryHelper2.default.isPreorderCart(cart);

    if (!foCart && !preorderCart) {
        return hasDelayMins ? txt.asapWithDelay(delayMins) : txt.asapWithoutDelay();
    } else if (preorderCart) {
        return hasDelayMins ? txt.preorderWithDelay(cart.submitAt, delayMins) : txt.preorderWithoutDelay(cart.submitAt);
    } else {
        return txt.futureOrder(cart.delivery.time);
    }
}

var TextProvider = function () {
    function TextProvider(i18n, timezone) {
        (0, _classCallCheck3.default)(this, TextProvider);

        this.i18n = i18n;
        this.timezone = timezone;
    }

    (0, _createClass3.default)(TextProvider, [{
        key: 'asapWithDelay',
        value: function asapWithDelay(delayMins) {
            var humanizedDelay = _Time2.default.humanizeMinutesDuration(delayMins);

            var upto = this.i18n('deliverytime_asap_upto', {
                params: { delayMins: humanizedDelay }
            });

            return upto;
        }
    }, {
        key: 'asapWithoutDelay',
        value: function asapWithoutDelay() {
            return this._getAsapTxt();
        }
    }, {
        key: 'preorderWithDelay',
        value: function preorderWithDelay(submitAt, delayMins) {
            var humanizedDelay = _Time2.default.humanizeMinutesDuration(delayMins);

            var uptoAfter = this.i18n('deliverytime_asap_upto_after', {
                params: {
                    delayMins: humanizedDelay,
                    after: this._formatTime(submitAt)
                }
            });

            return uptoAfter;
        }
    }, {
        key: 'preorderWithoutDelay',
        value: function preorderWithoutDelay(submitAt) {
            var after = this.i18n('deliverytime_asap_after', {
                params: {
                    after: this._formatTime(submitAt)
                }
            });

            return after;
        }
    }, {
        key: 'futureOrder',
        value: function futureOrder(deliveryTime) {
            return this.i18n('deliverytime_at_approx', {
                params: {
                    deliveryTime: this._formatTime(deliveryTime)
                }
            });
        }
    }, {
        key: '_getAsapTxt',
        value: function _getAsapTxt() {
            return this.i18n('deliverytime_asap');
        }
    }, {
        key: '_formatTime',
        value: function _formatTime(timestamp) {
            return _momentTimezone2.default.tz(timestamp, this.timezone).format("L LT");
        }
    }]);
    return TextProvider;
}();


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/FutureDelivery/TimeGuaranteeText.js
// module id = 897
// module chunks = 0